import React, { useState } from "react";
import "./Login.css";
import Logo from "../../assets/appImages/logo.png";
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";
import { NavLink } from "react-router-dom";
import UseLoginForm from "./requestForm/UseLoginForm";
import { FormError } from "../common/Input";

const Login = () => {
  const { register, errors, isLoading, onSubmit } = UseLoginForm();
  const [showPassword, setShowPassword] = useState(false);
  return (
    <div>
      <div className="empty-header-auth">
        <div className="content-img-logo-login-app">
          <img src={Logo} alt="Logo" className="img-logo-login-app" />
        </div>
      </div>
      <div className="container-page-login-app">
        <div className="auth-row">
          <div className="auth-col auth-right-side-col">
            <div className="auth-right-side-container">
              <div className="auth-form-container text-center pb-4">
                <h2 className="title-auth-form-text pt-5">Connexion</h2>
                <div className="mt-5">
                  <form id="auth-form" onSubmit={onSubmit}>
                    <div className="row auth-form-row">
                      <div className="col-md-12 auth-input-col mb-3">
                        <div className="auth-form-group">
                          <label className="form-label form-label-auth-login">
                            Adresse email
                          </label>
                          <input
                            type={`email`}
                            className="form-control auth-form-control"
                            id="email-or-username"
                            aria-label="Username"
                            placeholder="Email"
                            {...register("email")}
                          />
                          <FormError error={errors?.email?.message} />
                        </div>
                      </div>
                      <div className="col-md-12 auth-input-col mb-2">
                        <div className="auth-form-group position-relative">
                          <label className="form-label form-label-auth-login">
                            Mot de passe
                          </label>
                          <input
                            type={showPassword ? "text" : "password"}
                            className="form-control auth-form-control"
                            id="password"
                            placeholder="Mot de passe"
                            aria-label="Password"
                            aria-placeholder="***********"
                            {...register("password")}
                          />
                          <span
                            className="show-hide-password"
                            onClick={() => {
                              setShowPassword(!showPassword);
                            }}
                          >
                            {showPassword ? (
                              <AiFillEyeInvisible />
                            ) : (
                              <AiFillEye />
                            )}
                          </span>
                          <FormError error={errors?.password?.message} />
                        </div>
                      </div>
                      <div className="col-md-12 mt-3 text-right">
                        <span className="mt-2">
                          <NavLink
                            className="nav-link forget-password-link"
                            to="/mot-de-passe-oublie"
                            data-tooltip-content="Gestionnaires"
                          >
                            Mot de passe oublié
                          </NavLink>
                        </span>
                      </div>

                      <div className="col-md-8 offset-md-2 auth-submit-btn-container mt-5">
                        <button
                          type="submit"
                          className="btn auth-submit-btn trans-0-2"
                          disabled={isLoading}
                        >
                          {!isLoading ? (
                            `Connexion`
                          ) : (
                            <>
                              <span
                                className="spinner-border spinner-border-sm text-light me-1 d-inline-block"
                                role="status"
                              ></span>
                              <span>Chargement...</span>
                            </>
                          )}
                        </button>
                      </div>
                      {/* <div className="container-beetwen-connect my-4">
                        <div className="line-hr-connect">
                          <hr />
                        </div>
                        <p className="text-beetwen-connect mb-0">ou</p>
                        <div className="line-hr-connect">
                          <hr />
                        </div>
                      </div>
                      <div className="col-md-8 offset-md-2 auth-submit-btn-container mt-5">
                        <button
                          className="btn auth-submit-social-media trans-0-2"
                          type="button"
                        >
                          Continue avec Google
                        </button>
                      </div> */}
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
